export * from './modal.model';
